/**
 * Exchange.js
 *
 * @description :: A model definition.  Represents a database table/collection/etc.
 * @docs        :: https://sailsjs.com/docs/concepts/models-and-orm/models
 */

 
export default {
  attributes: {
    name:{
      type:'string',
    },
    letterId: {
      model: "instructionletter",
      required: true,
    },
    status: {
      type: 'string',
    },
    date: {
      type: 'ref',
      columnType: 'date',
      required: true,
    },
    clientRef: {
      type: 'string',
      allowNull: true,
    },
    exchangePrice:{
      type:'number',
      required:true
    },
    customerId:{
      model:'cliente',
      required:true
    },
    locals: {
      collection: 'local',
      via: 'quote'
    },
    maritimes: {
      collection: 'maritime',
      via: 'quote'
    },
    land: {
      collection: 'land',
      via: 'quote'
    },
    aamx: {
      collection: 'aamx',
      via: 'quote'
    },
    profitandloses: {
      collection: 'profitandloses',
      via: 'quote'
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/Quote.js